import { render, staticRenderFns } from "./Warenrücknahme.vue?vue&type=template&id=4c809750&scoped=true&"
import script from "./Warenrücknahme.vue?vue&type=script&lang=js&"
export * from "./Warenrücknahme.vue?vue&type=script&lang=js&"
import style0 from "./Warenrücknahme.vue?vue&type=style&index=0&id=4c809750&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c809750",
  null
  
)

export default component.exports